export const createReducer = ({ handlers, initialState }) => {
  return (state = initialState, action) => {
    const handler = handlers[action.type]

    return handler ? handler(state, action) : state
  }
}
